import {useEffect, useState} from 'react';

import Container from '@/components/Layout/Container/Container';
import appConfig from '@/config/appConfig.typed';
import {LOGIN_TYPE_CODE} from '@/consts/loginTypes';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import LoginFooter from './components/LoginFooter';
import PasswordLoginForm from './components/LoginForm/PasswordLoginForm';
import OtpLoginSection from './components/Otp/OtpLoginSection';
import useLoginFlow from './hooks/useLoginFlow';
import type {LoginErrorDetails} from './LoginPageV2.types';

const LoginPageV2 = () => {
    const [loginError, setLoginError] = useState<LoginErrorDetails>(null);
    const {
        currentMethod,
        otpChannel,
        otpChannels,
        canSwitchMethod,
        hasOtpTabs,
        isOtpCodeStep,
        switchMethod,
        selectOtpChannel,
        goToOtpCodeStep,
        resetOtpFlow,
    } = useLoginFlow();

    useEffect(() => {
        setLoginError(null);
    }, [currentMethod]);

    const {isLoginLanguageSelectEnabled} = appConfig.getLoginSettings();

    return (
        <div className='w-full pt-0-hw-offset ml:bg-primary-dark-5'>
            {/* @ts-ignore */}
            <WarningBannersTop source={WARNING_BANNER_SOURCE_TYPES.LOGIN} />
            <div className='flex h-full flex-col ml:py-8'>
                <Container className='flex flex-col justify-between bg-romance p-4 pt-0 ml:mb-auto ml:p-8'>
                    <div className='h-full w-full'>
                        {currentMethod === LOGIN_TYPE_CODE.LOGIN_PASSWORD && (
                            <PasswordLoginForm
                                loginError={loginError}
                                setLoginError={setLoginError}
                                isLoginLanguageSelectEnabled={isLoginLanguageSelectEnabled}
                            />
                        )}

                        {currentMethod === LOGIN_TYPE_CODE.OTP && (
                            <OtpLoginSection
                                otpChannel={otpChannel}
                                otpChannels={otpChannels}
                                hasOtpTabs={hasOtpTabs}
                                isOtpCodeStep={isOtpCodeStep}
                                selectOtpChannel={selectOtpChannel}
                                goToOtpCodeStep={goToOtpCodeStep}
                                resetOtpFlow={resetOtpFlow}
                                loginError={loginError}
                                setLoginError={setLoginError}
                                isLoginLanguageSelectEnabled={isLoginLanguageSelectEnabled}
                            />
                        )}

                        {!isOtpCodeStep && (
                            <LoginFooter
                                currentMethod={currentMethod}
                                onSwitch={switchMethod}
                                canSwitchMethod={canSwitchMethod}
                            />
                        )}
                    </div>
                    {/* @ts-ignore */}
                    <WarningBanners
                        source={WARNING_BANNER_SOURCE_TYPES.LOGIN}
                        className='mt-8 ml:mt-6'
                        contentClassName='bg-primary-dark-5 p-6 ml:p-6'
                    />
                </Container>
            </div>
        </div>
    );
};

export default LoginPageV2;
